import axios from "@/index";
const activities = {
  state: {
    activitiesList: [],
    activitiesData: []
  },
  getters: {},
  actions: {
    getActivitiesList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setActivitiesList",
                (state, { activitiesList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getActivitiesById: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setActivitiesById",
                (state, { activitiesData: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setActivitiesList(state, action) {
      state.activitiesList = action.activitiesList;
    },
    setActivitiesById(state, action) {
      state.activitiesData = action.activitiesData;
    }
  }
};
export default activities;
